// @ts-nocheck
import React from 'react';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';

import Home from '../Containers/Home';
import Tools from '../Containers/Tools';
import CollegeFinder from '../Containers/Tools/CollegeFinder/index';
import Timeline from '../Containers/Tools/Timeline';
import AffiliateCalculator from '../Containers/Tools/AffiliateCalculator';
import ProfileEvaluation from '../Containers/Tools/ProfileEvaluation';
import { init } from '../Utilities/GoogleAnalytics';
import Reviews from '../Containers/Reviews';
import About from '../Containers/About';
import Contact from '../Containers/Contact';
import Affiliate from '../Containers/Affiliate';
import AffiliateApply from '../Containers/Affiliate/apply';

export default function Routes() {
  init();

  function FourOFour() {
    // @ts-ignore
    window.location = '/';
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/home" component={Home} />
        <Route exact path="/" component={Home} />
        <Route exact path="/tools" component={Tools} />
        <Route exact path="/reviews" component={Reviews} />
        <Route exact path="/about" component={About} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/tools/college-finder" component={CollegeFinder} />
        <Route exact path="/tools/timeline" component={Timeline} />
        <Route exact path="/tools/profile-evaluation" component={ProfileEvaluation} />
        <Route exact path="/affiliate" component={Affiliate} />
        <Route exact path="/affiliate/earnings" component={AffiliateCalculator} />
        <Route exact path="/affiliate/apply" component={AffiliateApply} />
        <Route component={() => FourOFour()} />
      </Switch>
    </Router>
  );
}
